import { mapMutations, mapState } from 'vuex'
import InputRender from '@/mixin/render-input.js'
export default {
    data () {
        return {
            type: 'CP_Qunty_Type',
            paramsList: [ 
                {   
                    title: '冷冻水泵规格1',
                    prop: 'CP_Type_1',
                    Brand: 'Siemens',
                    Model: 'XX55-123',
                    disabled: false,
                    list: [
                        {
                            title: '类型',  // 缺少
                            type: 'radio',
                            fullWidth: '1',
                            vModel: '1',
                            radioList: [
                                { label: '卧式', id: '1' },
                                { label: '立式', id: '2' },
                            ],
                        },
                        {
                            title: '变频',  // 缺少
                            type: 'radio',
                            vModel: '1',
                            radioList: [
                                { label: '变频', id: '1' },
                                { label: '定频', id: '2' },
                            ],
                        },
                        {
                            title: '数量',
                            prop: 'CP_Qunty_Type_1',
                            System_Configuration: true,
                            disabled: true,
                            type: 'input',
                            vModel: '1',
                        },
                        {
                            title: '冷冻水流量(m³/h)',
                            prop: 'L',
                            type: 'input',
                            vModel: '490.0',
                        },
                        {
                            title: '冷冻水扬程(m)',
                            prop: 'H',
                            type: 'input',
                            vModel: '60.0',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: '98.97',
                        },
                        {
                            title: '频率(Hz)',
                            prop: 'Hz',
                            type: 'input',
                            vModel: '50.0',
                        },
                        {
                            title: '最低频率(Hz)',
                            prop: 'Hz_min',
                            type: 'input',
                            vModel: '38.0',
                        },
                    ],
                },
                {   
                    title: '冷冻水泵规格2',
                    prop: 'CP_Type_2',
                    Brand: 'Siemens',
                    Model: 'XX55-123',
                    disabled: false,
                    list: [
                        {
                            title: '类型',  // 缺少
                            type: 'radio',
                            fullWidth: '1',
                            vModel: '1',
                            radioList: [
                                { label: '卧式', id: '1' },
                                { label: '立式', id: '2' },
                            ],
                        },
                        {
                            title: '变频',  // 缺少
                            type: 'radio',
                            vModel: '1',
                            radioList: [
                                { label: '变频', id: '1' },
                                { label: '定频', id: '2' },
                            ],
                        },
                        {
                            title: '数量',
                            prop: 'CP_Qunty_Type_2',
                            System_Configuration: true,
                            disabled: true,
                            type: 'input',
                            vModel: '2',
                        },
                        {
                            title: '冷冻水流量(m³/h)',
                            prop: 'L',
                            type: 'input',
                            vModel: '490.0',
                        },
                        {
                            title: '冷冻水扬程(m)',
                            prop: 'H',
                            type: 'input',
                            vModel: '60.0',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: '98.97',
                        },
                        {
                            title: '频率(Hz)',
                            prop: 'Hz',
                            type: 'input',
                            vModel: '50.0',
                        },
                        {
                            title: '最低频率(Hz)',
                            prop: 'Hz_min',
                            type: 'input',
                            vModel: '38.0',
                        },
                    ],
                },
                {   
                    title: '冷冻水泵规格3',
                    prop: 'CP_Type_3',
                    Brand: 'None',
                    Model: '0000-000',
                    disabled: false,
                    list: [
                        {
                            title: '类型',  // 缺少
                            type: 'radio',
                            fullWidth: '1',
                            vModel: '1',
                            radioList: [
                                { label: '卧式', id: '1' },
                                { label: '立式', id: '2' },
                            ],
                        },
                        {
                            title: '变频',  // 缺少
                            type: 'radio',
                            vModel: '1',
                            radioList: [
                                { label: '变频', id: '1' },
                                { label: '定频', id: '2' },
                            ],
                        },
                        {
                            title: '数量',
                            prop: 'CP_Qunty_Type_3',
                            System_Configuration: true,
                            disabled: true,
                            type: 'input',
                            vModel: '0',
                        },
                        {
                            title: '冷冻水流量(m³/h)',
                            prop: 'L',
                            type: 'input',
                            vModel: '0.0',
                        },
                        {
                            title: '冷冻水扬程(m)',
                            prop: 'H',
                            type: 'input',
                            vModel: '0.0',
                        },
                        {
                            title: '功率(kw)',
                            prop: 'Pe',
                            type: 'input',
                            vModel: '0.0',
                        },
                        {
                            title: '频率(Hz)',
                            prop: 'Hz',
                            type: 'input',
                            vModel: '0.0',
                        },
                        {
                            title: '最低频率(Hz)',
                            prop: 'Hz_min',
                            type: 'input',
                            vModel: '0.0',
                        },
                    ],
                },
                {
                    list: [
                        {
                            title: '冷冻水管路定压差(kPa)',
                            prop: 'Const_DP',
                            type: 'input',
                            vModel: '15.0',
                            System_Configuration: true,
                        },
                    ],
                },
            ],
        }
    },

    mixins: [InputRender],

}